import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  NgZone,
} from '@angular/core';
import { PlatformService } from '../services/platform.service';

@Directive({
  selector: '[appMobileScrollOnFocus]',
  standalone: true
})
export class ScrollOnFocusDirective {
  @Input() appMobileScrollOnFocus = true;
  constructor(
    private el: ElementRef,
    private platform: PlatformService,
    private _ngZone: NgZone
  ) {}

  @HostListener('focus') onFocus(): void {
    if (
      this.appMobileScrollOnFocus === false ||
      (!this.platform.ANDROID && !this.platform.IOS)
    ) {
      return;
    }
    this.scrollIntoView();
  }

  private scrollIntoView(): void {
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const header = document
          .getElementById('header')
          .getBoundingClientRect();
        const offset = this.el.nativeElement.offsetTop;

        window.scrollTo({
          top: offset - header.height - 30,
          behavior: 'smooth',
        });
      }, 100);
    });
  }
}
